import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import EmployeeRoute from './components/employee/EmployeeRoute';
import AdminRoute from './components/admin/AdminRoute';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/emp" element={<EmployeeRoute />} />
          <Route path="/admin" element={<AdminRoute />} />
          <Route path="/" element={<EmployeeRoute />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
